/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptions interface.
 */
export function instanceOfFxIdApplicationPublicDataBuilderPublicDataBaseSupportOptions(value) {
    return true;
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptionsFromJSON(json) {
    return FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptionsFromJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'ZendeskEmbedKey': json['ZendeskEmbedKey'] == null ? undefined : json['ZendeskEmbedKey'],
    };
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptionsToJSON(json) {
    return FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptionsToJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'ZendeskEmbedKey': value['ZendeskEmbedKey'],
    };
}
//# sourceMappingURL=FxIdApplicationPublicDataBuilderPublicDataBaseSupportOptions.js.map